import { useDebounce } from 'ahooks';
import { DEFAULT_LOADING_DEBOUNCE_TIME } from '@/constants/config';

/**
 * 防抖的loading状态
 * - wait默认300毫秒
 */
const useLoading = (loadingData: boolean, wait?: number) => {
  return useDebounce(loadingData, { wait: wait || DEFAULT_LOADING_DEBOUNCE_TIME });
};

export default useLoading;
